import { render, staticRenderFns } from "./noticeList.vue?vue&type=template&id=004728ce&scoped=true&"
import script from "./noticeList.vue?vue&type=script&lang=js&"
export * from "./noticeList.vue?vue&type=script&lang=js&"
import style0 from "./noticeList.vue?vue&type=style&index=0&id=004728ce&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004728ce",
  null
  
)

export default component.exports